import gql from 'graphql-tag';
import { TEAM_TYPE } from './TeamType.gql';

export const ADD_TEAM = gql`
  ${TEAM_TYPE}
  mutation addTeam($employees: [Int], $managers: [Int], $teamData: TeamInput!) {
    createTeam(employees: $employees, managers: $managers, teamData: $teamData) {
      team {
        ...TeamType
      }
    }
  }
`;
